import script from "./Area51.vue?vue&type=script&lang=js"
export * from "./Area51.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__